import BaseApiError from './base'

type BadRequestErrorReason = {
  reason: string
  description: string
}

class BadRequestError extends BaseApiError {
  readonly type = 'BAD_REQUEST'
  readonly errors: BadRequestErrorReason[]

  constructor(errors: BadRequestErrorReason[]) {
    super()

    this.errors = errors
  }
}

export default BadRequestError
